import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { AuthProvider } from "./context/auth";
import Escritorio from "./pages/escritorio";
import Login from "./pages/Login";
import "./Hero.css";

function App() {
  const pathname = window.location.pathname;

  return (
    <AuthProvider>
      <Router>
        <Route exact path="/" component={Login} />
        {pathname !== "/" && <Escritorio />}
      </Router>
    </AuthProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js